/**
 * `#download` — section tải ứng dụng Desktop. KHÔNG có trong bản thiết kế: user chốt 2026-09-28
 * thêm một section riêng giữa `#faq` và `#cta`, kèm một cột footer trỏ về đây.
 *
 * URL tải và SHA-256 KHÔNG nằm ở đây mà ở `apps/web/src/core/config/site.ts` (`DESKTOP_DOWNLOADS`):
 * chúng giống hệt nhau ở mọi ngôn ngữ, đi qua copy chỉ tạo thêm một chỗ để lệch.
 *
 * `requirement` chỉ ghi thứ ĐÃ KIỂM được từ tên tệp cài (`apple-silicon.dmg`, `windows-x64.exe`).
 * Phiên bản hệ điều hành tối thiểu CHƯA có nguồn nên cố ý không ghi — đừng thêm "Windows 10+" khi
 * đội app chưa xác nhận.
 */
interface DownloadHighlight {
  readonly icon: 'bell' | 'panel-right' | 'lock';
  readonly text: string;
}

interface DownloadMockMessage {
  readonly initials: string;
  readonly tint: 'brand' | 'warn';
  readonly text: string;
}

interface DownloadPlatform {
  /** Dòng nhỏ phía trên tên nền tảng trong nút. */
  readonly overline: string;
  readonly name: string;
  readonly requirement: string;
  readonly fileType: string;
  /** Lệnh tính SHA-256 trên chính hệ điều hành đó, cho tệp vừa tải về thư mục Downloads. */
  readonly verifyCommand: string;
}

export const download = {
  eyebrow: 'Ứng dụng Desktop',
  heading: 'Nexa trên máy tính bạn',
  lead: 'Cài Nexa cho macOS hoặc Windows để mở không gian làm việc bằng một cú nhấp, nhận thông báo ngay trên màn hình và làm việc trong một cửa sổ riêng, tách khỏi hàng chục tab trình duyệt.',
  highlights: [
    { icon: 'bell', text: 'Thông báo ngay trên màn hình, kể cả khi cửa sổ đang thu nhỏ' },
    { icon: 'panel-right', text: 'Cửa sổ riêng, không lạc giữa các tab trình duyệt' },
    { icon: 'lock', text: 'Cùng một tài khoản, dữ liệu đồng bộ với bản web' },
  ] as readonly DownloadHighlight[],
  platforms: {
    mac: {
      overline: 'Tải về cho',
      name: 'macOS',
      requirement: 'Mac chip Apple (M1 trở lên)',
      fileType: '.dmg',
      verifyCommand: 'shasum -a 256 ~/Downloads/nexa-*.dmg',
    },
    windows: {
      overline: 'Tải về cho',
      name: 'Windows',
      requirement: 'Windows 64-bit (x64)',
      fileType: '.exe',
      verifyCommand: '(Get-FileHash $HOME\\Downloads\\nexa-*.exe).Hash.ToLower()',
    },
  } satisfies Record<'mac' | 'windows', DownloadPlatform>,
  /** Nhãn gắn lên nút khớp hệ điều hành của người đang xem. */
  recommended: 'Máy của bạn',
  intelNote: 'Mac dùng chip Intel hiện chưa được hỗ trợ.',
  checksumToggle: 'Kiểm tra toàn vẹn tệp (SHA-256)',
  checksumHint:
    'Mở tệp SHA-256 của bản bạn đã tải, rồi chạy lệnh bên dưới: hai chuỗi phải trùng nhau.',
  checksumLink: 'Xem SHA-256',
  webPrompt: 'Không muốn cài đặt?',
  webLink: 'Dùng Nexa trên trình duyệt',
  /** Chữ nằm TRONG hình minh hoạ cửa sổ app. */
  mock: {
    channel: 'design-system',
    composer: 'Nhắn tin tới #design-system',
    notificationApp: 'Nexa',
    notificationTime: 'bây giờ',
    notificationTitle: 'Maya C. · #design-system',
    notificationBody: 'Bạn duyệt giúp bộ token v2 trước 15:00 nhé?',
    messages: [
      { initials: 'MC', tint: 'warn', text: 'Bộ token v2 đã xong, mọi người xem giúp nhé.' },
      { initials: 'JP', tint: 'brand', text: 'Mình mở topic riêng để góp ý cho gọn.' },
    ] as readonly DownloadMockMessage[],
  },
};
